import React from 'react'
import { Link } from 'react-router-dom'
import { CardHorizontal } from '../../components/CardHorizontal'

export const Blogs = () => {
  return (
    <div className='container py-5'>
        {/* Encabezado Principal */}
        <div className="text-center mb-5">
            <h1 className='display-5 fw-bold text-primary'>Blog de los Institutos</h1>
            <p className="text-muted">Recursos, reflexiones y estudios teológicos de nuestra comunidad.</p>
            <hr className="w-25 mx-auto border-primary opacity-75" />
        </div>

        <div className='row g-5'>
          
          {/* --- Columna del Buscador (Sidebar) --- */}
          <aside id='search_blogs' className='col-12 col-md-4'>
            <div className='card border-0 shadow-sm sticky-top' style={{ top: '2rem' }}>
              <div className='card-body p-4'>
                <h5 className='card-title mb-4 fw-bold'>
                  <i className="bi bi-search me-2"></i>Filtrar Contenido
                </h5>
                <form>
                  <div className='mb-3'>
                    <label htmlFor='search' className='form-label small fw-bold text-uppercase text-muted'>Palabra clave</label>
                    <input 
                        type='text' 
                        className='form-control form-control-lg border-2' 
                        id='search' 
                        placeholder='Ej: Teología, Música...' 
                    />
                  </div>
                  
                  {/* Categorías (Sugerencia para mejorar el diseño) */}
                  <div className="mb-4">
                    <label className='form-label small fw-bold text-uppercase text-muted'>Categorías</label>
                    <div className="d-flex flex-wrap gap-2">
                        <span className="badge rounded-pill bg-light text-dark border p-2 px-3 shadow-sm cursor-pointer">Teología</span>
                        <span className="badge rounded-pill bg-light text-dark border p-2 px-3 shadow-sm cursor-pointer">Ministerio</span>
                        <span className="badge rounded-pill bg-light text-dark border p-2 px-3 shadow-sm cursor-pointer">Historia</span>
                    </div>
                  </div>

                  <button type='submit' className='btn btn-primary w-100 py-2 fw-bold shadow-sm'>
                    Buscar Artículos
                  </button>
                </form>
              </div>
            </div>
          </aside>

          {/* --- Columna de Resultados --- */}
          <main id='show_blogs' className='col-12 col-md-8'>
            <div className="d-flex flex-column gap-4">
              
              <CardHorizontal 
                img={'https://via.placeholder.com/300x200'} // Ejemplo de imagen
                title={'La importancia del Ministerio Pastoral en el Siglo XXI'}
                description={'Una reflexión profunda sobre los retos actuales del pastorado y la necesidad de una formación constante bajo la sana doctrina.'}
                author={'Hno. Carlos Gallegos'}
                optional={(
                  <Link to='/blog' className='btn btn-link text-decoration-none fw-bold p-0'>
                    Leer artículo completo <i className="bi bi-arrow-right ms-1"></i>
                  </Link>
                )}
              />

              <CardHorizontal 
                img={'https://via.placeholder.com/300x200'}
                title={'Hacia una Música Superior: El legado del Himnario'}
                description={'¿Cómo mantener la esencia de nuestras alabanzas en un mundo de música comercial? Exploramos la teología detrás de nuestros himnos.'}
                author={'Secretaría de Educación'}
              />

              <CardHorizontal 
                img={'https://via.placeholder.com/300x200'}
                title={'Los Niños: La Iglesia del Mañana'}
                description={'La visión estratégica de invertir en la formación infantil como base para la preservación de la sana doctrina.'}
                author={'Comisión General Infantil'}
              />

              {/* Paginación simple (Sugerencia visual) */}
              <nav className="mt-5 border-top pt-4">
                <ul className="pagination justify-content-center">
                    <li className="page-item disabled"><span className="page-item p-2 px-3">Anterior</span></li>
                    <li className="page-item active"><span className="page-item p-2 px-3 bg-primary text-white rounded mx-1">1</span></li>
                    <li className="page-item"><span className="page-item p-2 px-3 border rounded mx-1">2</span></li>
                    <li className="page-item"><span className="page-item p-2 px-3 border rounded mx-1">Siguiente</span></li>
                </ul>
              </nav>

            </div> 
          </main> 

        </div>
    </div>
  )
}